import script from "./Feature.vue?vue&type=script&setup=true&lang=js"
export * from "./Feature.vue?vue&type=script&setup=true&lang=js"

import "./Feature.vue?vue&type=style&index=0&id=b131ce86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b131ce86"]])

export default __exports__